const actions = () => {
  const singleCheckFn = ($vm, subjects) => {
    //单选、判断检查
    let radioData = _.split($vm.checkValue[subjects.examQuestionsId], "[-]");
    $vm.$set(subjects, "answered", true);
    $vm.$set(subjects, "result", [radioData[0]]);
    return {
      // "text": radioData[1],
      value: radioData[0],
    };
  };
  const multiCheckFn = ($vm, subjects) => {
    // 多选 检查
    let data = _.map($vm.checkValue[subjects.examQuestionsId], (v) => {
      let _v = v.split("[-]");
      return {
        text: _v[1],
        value: _v[0],
      };
    });
    $vm.$set(subjects, "answered", data.length > 0 ? true : false);
    $vm.$set(subjects, "result", data ? _.map(data, item => item.value) : []);
    return data;
  };
  const inputCheckFn = ($vm, subjects) => {
    // 填空 检查
    let oldData = $vm.checkValue[subjects.examQuestionsId]
    // let sortKey = Object.keys(oldData).sort()
    // let newData = {} _.forEach(sortKey, (item, index) => newData[sortKey[index]] =  oldData[sortKey[index]])
    let data = _.map(oldData, (item, index) => _.trim(oldData[index]))
    let answered = subjects.fontNum > data.length ? false : _.every(data, Boolean)
    $vm.$set(subjects, "answered", answered);
    $vm.$set(subjects, "result", data || []);
    return data;
  };
  const subjectiveCheckFn = ($vm, subjects) => {
    // 主观题 检查
    let data = $vm.checkValue[subjects.examQuestionsId];
    $vm.$set(subjects, "answered", data?.length > 0 ? true : false);
    $vm.$set(subjects, "result", data || []);
    return data;
  };
  return new Map([
    // 数据检查更新map
    ["radio", singleCheckFn],
    ["judge", singleCheckFn],
    ["checkbox", multiCheckFn],
    ["input", inputCheckFn],
    ["subjective", subjectiveCheckFn],
  ]);
};
//题型组件 created 初始化 和 用户作答复现以及解析
const resAndAnalysis = () => {
  // 这里需要缓存用户作答以及标准答案
  const radio = ($vm) => {
    // $vm.$set($vm.checkValue, $vm.subjects.examQuestionsId, []);
    // 单选题以及判断题
    $vm.response = $vm.subjects.result; // 用户作答
    // let answer = $vm.subjects.answer; // 标准答案
    // let options = $vm.subjects.options; // 选项
    // 用户作答复现 回显正确答案
    $vm.echoTestQuestions($vm);
  };
  const input = ($vm) => {
    $vm.$set($vm.checkValue, $vm.subjects.examQuestionsId, []);
    $vm.formatStringContent($vm, 'hint')
    $vm.formatStringContent($vm, 'parse')
    // 填空题
    let str = $vm.formatStringContent($vm, 'name')
    var numArr = [];
    $vm.htmls = str.replace(/(<\/?p.*?>)/gi, "").replace(/（）|\(\)/g, function (word, p) {
      numArr.push(p);
      return "()—I—()";
    }).split("()").filter(item => item != '')
    // console.log('标题', $vm.htmls)
    $vm.subjects.fontNum = numArr.length;
    $vm.subjects.htmls = $vm.htmls;
    let response = !_.isNull($vm.subjects.result) && !_.isEmpty($vm.subjects.result) ? $vm.subjects.result: [] ; // 用户作答
    $vm.response = response; // 用户作答
    let answer = $vm.subjects.answer; // 标准答案
    // 回显正确答案
    if (!_.isNull(answer)) {
      let answerValue = _.filter(
        _.map($vm.subjects.options, (item) => {
          if (_.indexOf(answer, item.name) > -1) {
            return item.name;
          }
        }),
        (key) => key !== undefined
      ).join("；");
      $vm.$set($vm.subjects, "answerValue", answerValue);
    }
    let newAnswer = []
    // 处理默认表单字段
    if ($vm.htmls.length) {
      var data = {};
      let score = {}
      let i = 0;
      _($vm.htmls).forEach((item, index) => {
        if(item == '—I—') {
          data["text_" + index] = response[i]
          if(!_.isNull(answer)){
            newAnswer[index] = $vm.subjects?.answer[i]
          }
          // 渲染分数
          if($vm.subjects.scoreMethod?.value == 1) {
            score["score_" + index] = Number($vm.subjects.score) / $vm.subjects.options.length
          } else {
            score["score_" + index] = $vm.subjects.options[i]?.score 
          }
          i++
        }
      });
      $vm.fillValue = data;
      $vm.optionsScore = score;
    }
    // 有答案再处理
    if (!_.isNull(answer)) { 
      $vm.subjects.newAnswer = newAnswer
    }
    // 用户作答复现
    if (!_.isNull(response)) {
      $vm.$set($vm.checkValue, $vm.id, response);
      $vm.handleCheck();
    }
  };
  const checkbox = ($vm) => {
    $vm.response = $vm.subjects.result; // 用户作答
    $vm.echoTestQuestions($vm);
  };
  const subjective = ($vm) => {
    $vm.$set($vm.checkValue, $vm.subjects.examQuestionsId, '');
    // 主观题
    let response = $vm.subjects.result;
    $vm.response = response; // 用户作答
    // 用户作答复现
    if (!_.isNull(response)) {
      $vm.$set($vm.checkValue, $vm.id, response);
      $vm.handleCheck();
    }
    $vm.formatStringContent($vm, 'name')
    $vm.formatStringContent($vm, 'hint')
    $vm.formatStringContent($vm, 'parse')
  };
  return new Map([
    // 用户作答复现以及解析map
    ["radio", radio],
    ["judge", radio],
    ["checkbox", checkbox],
    ["input", input],
    ["subjective", subjective],
  ]);
};
export default {
  mixins: [$mixins.formControl],
  inject: ["exam"],
  props: {
    // 题目
    subjects: {
      type: [Object],
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      id: "", //题目id
      checkValue: {},
      checkBoxValue: {},
      answerValue: {}, //标准答案
      answerTransferred: "", //标准答案显示内容
      response: {}, //参考者回答
      isOver: false,
    };
  },
  created() {
    let subjects = this.subjects;
    this.id = subjects.examQuestionsId;
    this.resAndAnalysis().get(subjects.items.value)(this);
  },
  methods: {
    resAndAnalysis,
    handleCheck() {
      let subjects = this.subjects;
      let type = subjects.items.value;
      let data = actions().get(type)(this, subjects);
      let pushData = {
        questionsId: subjects.examQuestionsId,
        items: type,
        property: subjects.questionsProperty,
        settingId: subjects.settingId,
        score: subjects.score,
        treeinfoLevel: subjects.treeinfoLevel,
        treeinfoPid: subjects.treeinfoPid,
        results: (_.isArray(data) && data.length) || _.isObject(data) ? _.map(data, (item) => item?.value || item) : data,
      };
      // 答题才处理
      if (this.exam?.form) {
        var index = _.findIndex(this.exam.form, function (o) {
          return o.questionsId == subjects.examQuestionsId;
        });
        if (index > -1) {
          this.exam.$set(this.exam.form, index, pushData);
        } else {
          this.exam.$set(this.exam.form, this.exam.form.length, pushData);
        }
      }
      // console.log('处理数据', this.exam?.form )
    },
    setParImg(img) {
      return img ? JSON.parse(img) : [];
    },
    echoTestQuestions($vm) {
      $vm.$set($vm.checkValue, $vm.subjects.examQuestionsId, []);
      let { result, answer, options } = $vm.subjects;
      let type = $vm.subjects.items.value;
      // this.formatTitle($vm)
      this.formatStringContent($vm, 'name')
      this.formatStringContent($vm, 'hint')
      this.formatStringContent($vm, 'parse')
      if (!_.isNull(answer)) {
        var answerValue = _.filter(
          _.map(options, (item) => {
            if (_.indexOf(answer, item.examQuestionsOptionsId) > -1) {
              // return item.option+ (item.name ? '.'+ item.name:"")
              // 回显答案只显示选项
              return item.option
            }
          }),
          (key) => key !== undefined
        )
        // 单选题以及判断题
        if (type == "radio" || type == "judge") {
          answerValue = answerValue.toString();
        } else {
          answerValue = answerValue.join("；");
        }
        $vm.$set($vm.subjects, "answerValue", answerValue);
      }
      if (!_.isNull(result)) {
        var concatValue = _.filter(
          _.map(options, (item) => {
            if (_.indexOf(result, item.examQuestionsOptionsId) > -1) {
              return item.examQuestionsOptionsId + "[-]" + item.name;
            }
          }),
          (key) => key !== undefined
        );
        // 单选题以及判断题
        if (type == "radio" || type == "judge") {
          concatValue = concatValue.toString();
        }
        $vm.$set($vm.checkValue, $vm.id, concatValue);
        $vm.handleCheck();
      }
    },
    isEmpty(o) {
      //判断是否为null {} ''
      if (typeof o === "object") {
        for (let key in o) {
          return false;
        }
        return true;
      }
      return !o;
    },
    formatStringContent($vm, key) {
      let str = $vm.subjects[key] && $vm.subjects[key].replace(/style\s*?=\s*?(['"])[\s\S]*?\1/gi,'').replace(/(<\/?font.*?>)|(<\/?span.*?>)|(<\/?a.*?>)|(<\/?strong.*?>)|(<\/?em.*?>)|(<\/?b.*?>)/gi, '').replace(/<h[1-6]>(.*?)<\/h[1-6]>/gi, '<p>$1</p>')
      $vm.$set($vm.subjects, key, str);
      return str
    },
  },
  watch: {
    subjects(subjects, old) {
      if (subjects.examQuestionsId != old.examQuestionsId) {
        console.log('数据变化', 2, subjects, old)
        this.id = subjects.examQuestionsId;
        this.resAndAnalysis().get(subjects.items.value)(this);
      } else {
        // 试题组件处理显示答案
        // this.resAndAnalysis().get(subjects.items.value)(this);
        console.log('watch', subjects.items.value)

      }
    },
  },
};
